var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 74,
    viewBox: "0 0 65 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L5.90755 65.3777L32.4154 74L59.0924 65.3777L65 0H0ZM52.1693 21.1263H21.0573L21.7513 29.2862H51.4753L49.1732 53.7987L32.6016 58.2585V58.308H32.4154L15.7083 53.7987L14.6927 41.2781H22.7669L23.3594 47.5714L32.4154 49.9665L41.5052 47.5714L42.5208 37.2973H14.2695L12.1029 13.2473H52.9141L52.1693 21.1263Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/HTML.72e66f67e8e5ffc77124515a3ecac5f6.svg";
export { ForwardRef as ReactComponent };